/**
 * ChartTooltip — Estilos oficiais de tooltip para gráficos Recharts.
 * Uso obrigatório: importar CHART_TOOLTIP_STYLE e passar em contentStyle.
 * Proibido definir estilos de tooltip inline nos gráficos.
 */

export const CHART_TOOLTIP_STYLE: React.CSSProperties = {
  backgroundColor: 'hsl(var(--chart-tooltip-bg))',
  border: '1px solid hsl(var(--chart-tooltip-border))',
  borderRadius: 'var(--chart-tooltip-radius)',
  fontSize: '12px',
  boxShadow: 'var(--chart-tooltip-shadow)',
};

export const CHART_TOOLTIP_STYLE_BORDERLESS: React.CSSProperties = {
  ...CHART_TOOLTIP_STYLE,
  border: 'none',
};

import React from 'react';
